// Dev: empty string so api.ts uses relative paths (/api/...) which CRA's
// setupProxy.js forwards to localhost:5001 — same-origin, no CORS pain.
// Prod: real backend URL. Vercel sets REACT_APP_SERVER_URL explicitly.
export const SERVER_URL: string =
    process.env.REACT_APP_SERVER_URL ||
    (process.env.NODE_ENV === "production" ? "https://api.requesta.app" : "");

console.log("[Config] SERVER_URL:", SERVER_URL);

export const GOOGLE_CLIENT_ID: string =
    (process.env.REACT_APP_GOOGLE_CLIENT_ID as string) || "";
